import React from 'react';
import { usePosts } from '../contexts/PostContext';
import PostCard from '../components/posts/PostCard';

const SavedPosts: React.FC = () => {
  const { savedPosts, isLoading } = usePosts();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-[60vh]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-white"></div>
      </div>
    );
  }

  return (
    <div>
      <h1 className="text-2xl font-bold text-white mb-6">Saved Posts</h1>
      
      <div className="space-y-6">
        {savedPosts.length === 0 ? (
          <div className="text-center py-10">
            <p className="text-gray-500 dark:text-gray-400 mb-4">No saved posts yet</p>
            <p className="text-sm text-gray-400 dark:text-gray-500">
              Save posts to read them later
            </p>
          </div>
        ) : (
          savedPosts.map(post => (
            <PostCard key={post.id} post={post} />
          ))
        )}
      </div>
    </div>
  );
}

export default SavedPosts;